import { render, staticRenderFns } from "./TextAndImageFour.vue?vue&type=template&id=1accfbac&scoped=true&"
import script from "./TextAndImageFour.vue?vue&type=script&lang=js&"
export * from "./TextAndImageFour.vue?vue&type=script&lang=js&"
import style0 from "./TextAndImageFour.vue?vue&type=style&index=0&id=1accfbac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1accfbac",
  null
  
)

export default component.exports